"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationArrows = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _internal = require("../../hooks/internal");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const NavigationArrows = ({
  currentSlide,
  nextArrowVisible,
  previousArrowVisible,
  sliderRef
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [disabled, setDisabled] = (0, _react.useState)(false);
  const {
    products
  } = (0, _internal.useProducts)();
  // istanbul ignore next @preserve -- Check for animationEnded event not testable.
  sliderRef.current?.on('animationEnded', () => {
    setDisabled(false);
  });
  const onPreviousClick = (0, _react.useCallback)(() => {
    setDisabled(true);
    sliderRef.current?.prev();
  }, [sliderRef]);
  const onNextClick = (0, _react.useCallback)(() => {
    setDisabled(true);
    sliderRef.current?.next();
  }, [sliderRef]);
  if (products.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NavigationArrowsRoot, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SliderButton, {
      "data-testid": getTestId(_constants.REPLACEMENTS_PREVIOUS_BTN),
      disabled: disabled,
      visible: previousArrowVisible,
      onClick: onPreviousClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      variant: "subtitle1",
      fontWeight: "bold",
      children: [currentSlide, "/", products.length]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SliderButton, {
      "data-testid": getTestId(_constants.REPLACEMENTS_NEXT_BTN),
      disabled: disabled,
      visible: nextArrowVisible,
      onClick: onNextClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {
        fontSize: "inherit"
      })
    })]
  });
};
exports.NavigationArrows = NavigationArrows;